module.exports = __webpack_public_path__ + "img/logo-aicia.ecbf8010.jpg";